/* EXCENTRED® — Produktkarten: Fortschrittslinie beim Wischen + einmaliger Hinweis.
   Das Theme kann die Kartenbilder bereits wischen (slideshow-slides, scroll-snap);
   sichtbar war es nur nicht. Diese Datei ergänzt ausschließlich Anzeige und Hinweis –
   kein Eingriff in die Scroll-Position, damit scroll-snap unangetastet bleibt.
   Optik: assets/excentred-master.css (Abschnitt 28). */
(function () {
  'use strict';

  // R27 Ladezeit: Vorher las initGallery für JEDE Karte sofort scrollWidth/clientWidth und schrieb
  // danach Styles – bei 24–48 Karten erzwang das pro Karte ein neues Layout (Profil: ~2,3 s
  // Hauptthread auf Kollektionsseiten). Jetzt:
  //   1. Karten werden erst vorbereitet, wenn sie in die Nähe des Bildschirms kommen (IntersectionObserver)
  //   2. alle Messungen eines Durchgangs gebündelt in EINEM Frame, danach alle Schreibvorgänge
  //   3. Startwert der Linie ohne Messung (--ex-p: 0) – gemessen wird erst beim Wischen
  var galleryQueue = [];
  var galleryFrame = 0;
  var galleryIO = null;

  function bindGallery(gallery, scroller) {
    var frame = 0;
    function update() {
      frame = 0;
      var max = scroller.scrollWidth - scroller.clientWidth;
      gallery.style.setProperty('--ex-p', max > 0 ? (scroller.scrollLeft / max).toFixed(4) : 0);
    }
    scroller.addEventListener(
      'scroll',
      function () {
        if (!frame) frame = requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  function flushGalleries() {
    galleryFrame = 0;
    var batch = galleryQueue;
    galleryQueue = [];
    var ok = [];
    var i;
    // Lesen (ein Layout für alle)
    for (i = 0; i < batch.length; i++) {
      var scroller = batch[i].querySelector('slideshow-slides');
      if (!scroller) continue;
      ok.push([batch[i], scroller, scroller.scrollWidth - scroller.clientWidth >= 8]);
    }
    // Schreiben
    for (i = 0; i < ok.length; i++) {
      var g = ok[i][0];
      if (!ok[i][2]) {
        g.dataset.exSkip = '1';
        continue;
      }
      g.dataset.exBar = '1';
      g.style.setProperty('--ex-n', ok[i][1].children.length);
      g.style.setProperty('--ex-p', 0);
      bindGallery(g, ok[i][1]);
    }
  }

  function queueGallery(gallery) {
    if (gallery.dataset.exBar || gallery.dataset.exQueued) return;
    gallery.dataset.exQueued = '1';
    galleryQueue.push(gallery);
    if (!galleryFrame) galleryFrame = requestAnimationFrame(flushGalleries);
  }

  function initGallery(gallery) {
    if (gallery.dataset.exBar || gallery.dataset.exSeen || gallery.dataset.exSkip) return;
    // In Karussell-Reihen wischt man die Reihe, nicht die Bilder – dort keine Anzeige versprechen.
    if (gallery.closest('.resource-list__carousel')) {
      gallery.dataset.exSkip = '1';
      return;
    }
    var scroller = gallery.querySelector('slideshow-slides');
    if (!scroller || scroller.children.length < 2) {
      gallery.dataset.exSkip = '1';
      return;
    }
    gallery.dataset.exSeen = '1';
    if (!('IntersectionObserver' in window)) {
      queueGallery(gallery);
      return;
    }
    if (!galleryIO) {
      galleryIO = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            galleryIO.unobserve(entries[i].target);
            queueGallery(entries[i].target);
          }
        },
        { rootMargin: '300px 0px' }
      );
    }
    galleryIO.observe(gallery);
  }

  // Produktseite: Fortschrittslinie an der Unterkante der Vorschaubilder – der
  // Übergang Hauptbild → Vorschau bleibt frei. Graue Spur über die ganze Leiste,
  // das schwarze Segment liegt unter dem aktiven Vorschaubild und gleitet beim
  // Wischen des Hauptbilds stufenlos zum nächsten (wie auf den Produktkarten).
  // Galerie und Vorschau werden beim Stilwechsel neu gebaut – deshalb werden
  // Leiste und Vorschaubilder bei jedem Update frisch gesucht.
  function initPdpBar(box) {
    if (box.dataset.exBar) return;
    var scroller = box.querySelector('slideshow-slides');
    if (!scroller) return;
    var comp = box.closest('slideshow-component') || box.parentElement;
    box.dataset.exBar = '1';
    var frame = 0;
    function update() {
      frame = 0;
      var row = comp.querySelector('.slideshow-controls__thumbnails');
      if (!row) return;
      var thumbs = row.querySelectorAll('.slideshow-control');
      var n = Math.min(thumbs.length, scroller.children.length);
      row.dataset.exBar = '1';
      row.classList.toggle('ex-bar-single', n < 2);
      // Runde 19: Weniger Bilder, als in die Breite passen (mobil < 5) → die Vorschaubilder
      // verteilen sich gleichmäßig über die ganze Leiste statt links zu kleben.
      // Die Felder wachsen per CSS (flex-grow im Verhältnis der Fotoformate, Runde 80);
      // hier nur die Markierung.
      // Runde 80: Maßstab ist die normale Feldbreite aus excentred-master.css
      // (clamp(72px, 20vw, 112px)), nicht das aktuell gemessene Feld. Gefüllte Felder haben
      // jetzt das echte Fotoformat und sind höher; aus ihrer Höhe abgeleitet würde die
      // Entscheidung je nach Rundung kippen. Bis 4 Bilder füllt die Leiste immer (sonst liefe
      // sie z. B. am Tablet 48 px über und das 4. Vorschaubild wäre rechts angeschnitten).
      if (thumbs.length) {
        var base = Math.min(112, Math.max(72, window.innerWidth * 0.2));
        var room = row.parentElement ? row.parentElement.clientWidth : 0;
        row.classList.toggle('ex-thumbs-fill', n >= 2 && room > 0 && (thumbs.length <= 4 || thumbs.length * base < room - 1));
      }
      if (n < 2) return;
      var w = scroller.clientWidth || 1;
      var f = Math.max(0, Math.min(n - 1, scroller.scrollLeft / w));
      var i = Math.floor(f);
      var t = f - i;
      var a = thumbs[i];
      var b = thumbs[Math.min(i + 1, n - 1)];
      var x = a.offsetLeft + (b.offsetLeft - a.offsetLeft) * t;
      var tw = a.offsetWidth + (b.offsetWidth - a.offsetWidth) * t;
      row.style.setProperty('--ex-tx', x.toFixed(1) + 'px');
      row.style.setProperty('--ex-tw', tw.toFixed(1) + 'px');
    }
    function soon() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    scroller.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    update();
    setTimeout(update, 600);
  }

  // --------------------------------------------------------------------------
  // Bookmark statt Herz – überall dort, wo die Swym-App ihr eigenes Icon einsetzt.
  // Gezeichnet wird derselbe Pfad wie auf der Produktkarte und in
  // assets/ex-icon-bookmark.svg: viewBox 20, Kontur in currentColor, keine Füllung.
  // Damit erbt das Icon die Header-Farbe (schwarz/weiß) und hat dieselbe
  // Strichstärke wie Menü, Suche und Warenkorb.
  // --------------------------------------------------------------------------
  var EX_BOOKMARK = 'M6.1 2.9h7.8c.9 0 1.6.7 1.6 1.6v12.6L10 13.6l-5.5 3.5V4.5c0-.9.7-1.6 1.6-1.6Z';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function toBookmark(svg) {
    if (!svg || svg.nodeName.toLowerCase() !== 'svg') return;
    // Nicht nur auf die eigene Markierung verlassen: Swym schreibt den Herz-Pfad
    // nach einem Klick erneut in dasselbe <svg>, ohne das Attribut zu entfernen.
    // Deshalb zählt allein, was gerade drinsteht – und der Durchlauf heilt sich selbst.
    var only = svg.firstElementChild;
    if (svg.childElementCount === 1 && only && only.getAttribute('d') === EX_BOOKMARK) return;
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('fill', 'none');
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', EX_BOOKMARK);
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    svg.setAttribute('data-ex-bookmark', '');
  }

  // Swym zeichnet sein Herz immer mit demselben Pfad. Darüber finden wir es zuverlässig –
  // auch in Meldungen, im Bestätigungsfenster und nachdem die App den Button neu aufbaut.
  var EX_HEART = 'path[d^="M19.6706 5.4736"]';

  function sweepBookmarks() {
    var i;
    var hearts = document.querySelectorAll(EX_HEART);
    for (i = 0; i < hearts.length; i++) {
      toBookmark(hearts[i].ownerSVGElement || hearts[i].closest('svg'));
    }
    var known = document.querySelectorAll(
      '#header-component .swym-header-icon-html svg,' +
        '#swym-atw-button-container svg,' +
        '.atw-button svg'
    );
    for (i = 0; i < known.length; i++) toBookmark(known[i]);
  }

  function scan() {
    var list = document.querySelectorAll('.card-gallery:not([data-ex-bar]):not([data-ex-seen]):not([data-ex-skip])');
    for (var i = 0; i < list.length; i++) initGallery(list[i]);
    var pdp = document.querySelectorAll('.product-information media-gallery slideshow-container:not([data-ex-bar])');
    for (var j = 0; j < pdp.length; j++) initPdpBar(pdp[j]);
    scanWish();
    sweepBookmarks();
  }

  // Newsletter-Überschrift: "X-CLUB" darf nicht am Bindestrich umbrechen.
  // Der Text steht in einer Editor-Einstellung, deshalb hier der geschützte Bindestrich (U+2011).
  function fixNewsletterHyphen() {
    var heads = document.querySelectorAll('.shopify-section:has(.email-signup-block) :is(h1,h2,h3,h4,h5,h6)');
    for (var i = 0; i < heads.length; i++) {
      var el = heads[i];
      if (el.textContent.indexOf('X-CLUB') === -1) continue;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf('X-CLUB') !== -1) {
          node.nodeValue = node.nodeValue.replace(/X-CLUB/g, 'X\u2011CLUB');
        }
      }
    }
  }

  // --- Wunschlisten-Herz auf der Produktkarte -----------------------------
  // Läuft über die Swym-App (_swat): addToWishList / removeFromWishList / fetch.
  // Ohne Swym passiert nichts – das Herz bleibt dann einfach ohne Funktion und wird ausgeblendet.
  var swymApi = null;
  var wishIds = null;

  function whenSwym(fn) {
    if (swymApi) {
      fn(swymApi);
      return;
    }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      swymApi = swat;
      fn(swat);
    });
  }

  function paintWish() {
    if (!wishIds) return;
    var list = document.querySelectorAll('[data-ex-wish]');
    for (var i = 0; i < list.length; i++) {
      var on = wishIds[list[i].getAttribute('data-empi')] === true;
      list[i].classList.toggle('ex-wish--on', on);
      list[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function closeWishPanels(except) {
    var open = document.querySelectorAll('[data-ex-wish-panel]:not([hidden])');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].hidden = true;
    }
  }

  function saveWish(btn, epi) {
    whenSwym(function (swat) {
      var product = {
        empi: parseInt(btn.getAttribute('data-empi'), 10),
        epi: parseInt(epi || btn.getAttribute('data-epi'), 10),
        du: btn.getAttribute('data-du')
      };
      btn.classList.add('ex-wish--on');
      btn.setAttribute('aria-pressed', 'true');
      if (wishIds) wishIds[btn.getAttribute('data-empi')] = true;
      swat.addToWishList(product, function () {}, function () {
        btn.classList.remove('ex-wish--on');
        btn.setAttribute('aria-pressed', 'false');
        if (wishIds) wishIds[btn.getAttribute('data-empi')] = false;
      });
    });
  }

  function onWishClick(event) {
    var btn = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    var panel = btn.hasAttribute('data-ex-wish-sizes')
      ? btn.parentElement.querySelector('[data-ex-wish-panel]')
      : null;
    // Noch nicht gemerkt und Größen vorhanden → erst Größe fragen.
    if (panel && !btn.classList.contains('ex-wish--on')) {
      closeWishPanels(panel);
      panel.hidden = !panel.hidden;
      return;
    }
    if (panel) panel.hidden = true;
    // Produktseite: immer die gerade gewählte Variante merken.
    if (btn.hasAttribute('data-ex-wish-pdp')) {
      var idEl = document.querySelector('.product-details form[action*="/cart/add"] input[name="id"]');
      if (idEl && idEl.value) btn.setAttribute('data-epi', idEl.value);
    }
    whenSwym(function (swat) {
      var product = {
        empi: parseInt(btn.getAttribute('data-empi'), 10),
        epi: parseInt(btn.getAttribute('data-epi'), 10),
        du: btn.getAttribute('data-du')
      };
      var was = btn.classList.contains('ex-wish--on');
      btn.classList.toggle('ex-wish--on', !was);
      btn.setAttribute('aria-pressed', was ? 'false' : 'true');
      if (wishIds) wishIds[btn.getAttribute('data-empi')] = !was;
      var revert = function () {
        btn.classList.toggle('ex-wish--on', was);
        btn.setAttribute('aria-pressed', was ? 'true' : 'false');
        if (wishIds) wishIds[btn.getAttribute('data-empi')] = was;
      };
      if (was) {
        swat.removeFromWishList(product, function () {}, revert);
      } else {
        swat.addToWishList(product, function () {}, revert);
      }
    });
  }

  function scanWish() {
    var list = document.querySelectorAll('[data-ex-wish]:not([data-ex-wish-ready])');
    if (!list.length) return;
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('data-ex-wish-ready', '1');
      list[i].addEventListener('click', onWishClick);
    }
    var chips = document.querySelectorAll('[data-ex-wish-panel]:not([data-ready]) .ex-wish-sizes__item');
    for (var j = 0; j < chips.length; j++) {
      chips[j].addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var chip = event.currentTarget;
        var panel = chip.closest('[data-ex-wish-panel]');
        var btn = panel.parentElement.querySelector('[data-ex-wish]');
        panel.hidden = true;
        saveWish(btn, chip.getAttribute('data-epi'));
      });
    }
    var panels = document.querySelectorAll('[data-ex-wish-panel]:not([data-ready])');
    for (var k = 0; k < panels.length; k++) panels[k].setAttribute('data-ready', '1');
    paintWish();
    if (wishIds) return;
    whenSwym(function (swat) {
      document.documentElement.classList.add('ex-wish-live');
      if (typeof swat.fetch !== 'function') return;
      swat.fetch(
        function (items) {
          wishIds = {};
          (items || []).forEach(function (item) {
            wishIds[String(item.empi)] = true;
          });
          paintWish();
        },
        function () {}
      );
    });
  }

  function centerActiveTab() {
    var active = document.querySelector('.ex-tabs__link--active');
    if (!active) return;
    var list = active.closest('.ex-tabs__list');
    if (!list || list.scrollWidth <= list.clientWidth) return;
    // Position relativ zur Liste messen – offsetLeft bezieht sich auf den nächsten
    // positionierten Vorfahren und liefert im Kollektionsraster falsche Werte.
    var r = active.getBoundingClientRect();
    var lr = list.getBoundingClientRect();
    list.scrollLeft += (r.left - lr.left) - (list.clientWidth - r.width) / 2;
  }

  // Der Impuls auf der ersten Karte soll laufen, wenn die Seite steht – nicht mitten im Laden.
  function markReady() {
    setTimeout(function () {
      document.documentElement.classList.add('ex-cards-ready');
    }, 400);
  }

  // Nur einmal pro Seitenaufruf: ist der Impuls durchgelaufen, sperrt .ex-hint-done ihn –
  // für „Mehr laden“ und für Filterwechsel, die das Raster neu aufbauen.
  document.addEventListener('animationend', function (event) {
    if (event.animationName !== 'ex-card-hint' && event.animationName !== 'ex-card-hint-bar') return;
    document.documentElement.classList.add('ex-hint-done');
  });

  function start() {
    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest('[data-ex-wish-panel]') && !event.target.closest('[data-ex-wish]')) {
          closeWishPanels(null);
        }
      },
      true
    );
    scan();
    centerActiveTab();
    fixNewsletterHyphen();
    if (document.readyState === 'complete') {
      markReady();
    } else {
      window.addEventListener('load', markReady, { once: true });
    }

    // Swym baut seinen Button bei jedem Variantenwechsel neu und schreibt dabei
    // wieder das Herz hinein. Der Tausch läuft deshalb direkt im Beobachter –
    // Mutation-Callbacks laufen vor dem nächsten Bildaufbau, das Herz wird so nie
    // gemalt. Alles andere (Galerien, Merken-Buttons) bleibt gebündelt.
    var pending = 0;
    new MutationObserver(function () {
      sweepBookmarks();
      if (pending) return;
      pending = setTimeout(function () {
        pending = 0;
        scan();
      }, 250);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['d'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
